import {action, computed, observable, reaction} from 'mobx';

export default class {
  defaultModal = {
    email: '',
    isEditMode: false,
    name: '',
    nameSnapshot: '',
    surname: '',
    surnameSnapshot: '',
    url: '',
  }

  @observable isPageReady = false;
  @observable modal = this.defaultModal;
  @observable paymentDate = '';
  @observable acceptedTermsOfServicePdfUrl = '';
  @observable bankName = '';
  @observable costPerRecipient;
  @observable createDonationFormPath;
  @observable currentScreen = 0;
  @observable defaultTermsOfServicePdfUrl = '';
  @observable isFetchingRecipientData = true;
  @observable last4 = '';
  @observable latestScreen;
  @observable logoId = '';
  @observable offlinePayment;
  @observable paymentMethod = '';
  @observable recipientData = [];
  @observable recipientDataUrl = '';
  @observable selectedSendOnDayOfMonth;
  @observable sendOnDayOfMonth;
  @observable acceptedTermsOfService = false;
  @observable scheduleEmailBtnClicked = false;

  setPageReadyOnLatestScreenChange = reaction(
    () => this.latestScreen,
    (_screen) => {
      this.isPageReady = true;
    }
  );

  @computed get emailsScheduled() {
    return this.sendOnDayOfMonth > 0;
  }

  @computed get hasRecipients() {
    return this.recipientCount > 0;
  }

  @computed get recipientCount() {
    return this.recipientData.length;
  }

  @computed get subscriptionAmount() {
    return this.recipientCount * this.costPerRecipient;
  }

  @computed get showWizard() {
    return this.latestScreen >= 0 && !this.offlinePayment;
  }

  @computed get wizardPercentComplete() {
    switch(this.latestScreen) {
      case 0: return 25;
      case 1: return 50;
      case 2: return 75;
      default: return null;
    }
  }

  @computed get paymentMethodText() {
    switch (this.paymentMethod) {
      case 'stripe':
        return this.last4 ? `Card ending in ${this.last4}` : 'Credit Card';
      case 'plaid':
        return this.last4 ? `Account ending in ${this.last4}` : `${this.bankName} account`;
      default: return null;
    }
  }

  @computed get fullNameSnapshot () {
    return `${this.modal.nameSnapshot} ${this.modal.surnameSnapshot}`;
  }

  @action getRecipientData = () => {
    this.isFetchingRecipientData = true;

    $.getJSON(this.recipientDataUrl, action((data) => {
      this.recipientData = data;
    })).always(action(() => {
      this.isFetchingRecipientData = false;
    }));
  }

  @action setModalValue = (key, value) => (
    this.modal[key] = value
  )

  @action setModal = (modal) => {
    this.modal = {...this.defaultModal, ...modal};
  };

  @action resetModal = () => {
    this.modal = this.defaultModal;
  };

  @action setPaymentDate = (value) => {
    this.paymentDate = new Date(value);
  };
}
